


































































import {Component, Emit, PropSync} from "vue-property-decorator";
import {PickingList, PickingListDelivery} from "@/interfaces/entity";
import moment from 'moment';
import {PickingListDeliveryStore} from "@/modules/pickinglistdeliveries";
import {PickingListDeliveryType} from "@/enums/type";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
import {PickingListDeliveryStatus} from "@/enums/status";
import PLDeliveryStatusLabel
    from "@/modules/pickinglistdeliveries/shared/component/PickingListDeliveryStatusLabel/index.vue";
import TooltipLabel from "@/shared/components/TooltipLabel/TooltipLabel.vue";

@Component({
    name: "PLDeliveryTable",
    components: {TooltipLabel, PLDeliveryStatusLabel}
})
export default class extends mixins(CommonMixin) {
    @PropSync("dataSource", {required: true}) syncDataSource!: Array<PickingList>;
    moment = moment;
    PickingListDeliveryType = PickingListDeliveryType;
    PickingListDeliveryStatus = PickingListDeliveryStatus;
    columns = [
        {
            title: "Thao tác",
            dataIndex: "id",
            key: "action",
            scopedSlots: {customRender: "action"},
            width: 120,
        },
        {
            title: "Mã xuất kho",
            dataIndex: "code",
            key: "code",
            width: 120,
            ellipsis: true,
            scopedSlots: {customRender: "code"}
        },
        {
            title: "Ngày, giờ phân công",
            dataIndex: "createdDate",
            key: "createdDate",
            width: 150,
            ellipsis: true,
            scopedSlots: {customRender: "createdDate"}
        },
        {
            title: "Tuyến phát",
            dataIndex: "targetRowGuid",
            key: "targetRowGuid",
            scopedSlots: {customRender: "target"},
            width: 120,
            ellipsis: true
        },
        {
            title: "Tổng đơn",
            dataIndex: "ladingQuantity",
            key: "ladingQuantity",
            width: 80
        },
        {
            title: "Tổng thu NN",
            dataIndex: "receiverCollect",
            key: "receiverCollect",
            scopedSlots: {customRender: "receiverCollect"},
            width: 120,
            ellipsis: true
        },
        {
            title: "GDV phân công",
            dataIndex: "createdBy.employee.fullname",
            key: "createdByRowGuid",
            width: 120,
            ellipsis: true,
            scopedSlots: {customRender: 'createdByName'}
        },
        {
            title: "Trạng thái",
            dataIndex: "status",
            key: "status",
            scopedSlots: {customRender: 'status'},
            width: 120,
            ellipsis: true
        }
    ];

    get pagination(): object {
        return {
            current: PickingListDeliveryStore.meta?.page,
            pageSize: PickingListDeliveryStore.meta?.limit,
            total: PickingListDeliveryStore.meta?.total,
            showTotal: (total: number) => `Tổng cộng ${total} bảng kê`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    @Emit("onChangePage")
    onChangePage(pagination: any) {
        return pagination;
    }

    @Emit("see-detail")
    seeDetail(id: number) {
        return id;
    }

    @Emit("print")
    print(id: number) {
        return id;
    }

    @Emit('delete')
    deletePickingListDelivery(id: number) {
        return id;
    }

    canDeletePickingListDelivery(pickingListDelivery: PickingListDelivery): boolean {
        if (pickingListDelivery.type === PickingListDeliveryType.Employee && pickingListDelivery.status === PickingListDeliveryStatus.WaitingConfirm)
            return true;
        else if (pickingListDelivery.type === PickingListDeliveryType.Partner)
            return true;
        else
            return false;
    }

    canAddBillToPickingList(pickingListDelivery: PickingListDelivery): boolean {
        if (pickingListDelivery.type === PickingListDeliveryType.Employee && pickingListDelivery.status === PickingListDeliveryStatus.WaitingConfirm)
            return true;
        else if (pickingListDelivery.type === PickingListDeliveryType.Partner)
            return true;
        else
            return false;
    }

    addBillLadingToPickingList(pickingListDelivery: PickingListDelivery) {
        if (pickingListDelivery.type == PickingListDeliveryType.Employee)
            this.$router.push({ name: 'addBillToPickingListDeliveryEmployee', params: { code: pickingListDelivery.code } });
        else
            this.$router.push({ name: 'addBillToPickingListDeliveryPartner', params: { code: pickingListDelivery.code } });
    }
}
